module.exports = __webpack_public_path__ + "502b45aabb314702a2420c0fec36a5b2.pdf";